import * as types from './action_types';
import CommentsManager from '../../services/comments_manager';
import DateMaster from '../utils/date_master';

export const reset = () => {
  return { type: types.WORD_COMMENTS_RESET };
}

export const fetch = (wordText, showLoading = true) => {
  return async(dispatch) => {
    try {
      if (showLoading) {
        dispatch({ type: types.WORD_COMMENTS_RETRIEVING });
      }
      const commentsData = await CommentsManager.forWord(wordText);
      const comments = []
      for (let commentsDataItem of commentsData) {
        comments.push({
          slug: commentsDataItem.slug,
          userSlug: commentsDataItem.user_slug,
          userName: commentsDataItem.user_name,
          content: commentsDataItem.content,
          wordText: commentsDataItem.word_text,
          createdAt: DateMaster.parseUTC(commentsDataItem.created_at),
          likedBy: commentsDataItem.liked_by
        });
      }
      dispatch({ type: types.WORD_COMMENTS_RETRIEVED, comments });
    } catch(error) {
      dispatch({ type: types.WORD_COMMENTS_ERROR, error });
    }
  }
}

export const save = (slug, content, wordText) => {
  return async(dispatch) => {
    let commentData = {};
    const isNew = !slug;
    try {
      if (isNew) {
        commentData = await CommentsManager.createComment(wordText, content);
      } else {
        commentData = await CommentsManager.updateComment(slug, content);
      }
      const comment = {
        slug: commentData.slug,
        userSlug: commentData.user_slug,
        userName: commentData.user_name,
        content: commentData.content,
        wordText: commentData.word_text,
        createdAt: DateMaster.parseUTC(commentData.created_at),
        likedBy: commentData.liked_by
      }
      dispatch({ type: types.WORD_COMMENT_SAVED, comment, isNew })
    } catch(error) {
      dispatch({ type: types.WORD_COMMENTS_ERROR, error });
    }
  }
}

export const destroy = (comment) => {
  return async(dispatch) => {
    try {
      await CommentsManager.deleteComment(comment.get('slug'));
      dispatch(fetch(comment.get('wordText')));
    } catch(error) {
      dispatch({ type: types.WORD_COMMENTS_ERROR, error });
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/word_comments/actions.js